import { Image, Link } from "@custom/schema";
import React from "react";
import { LinkedIn2Icon, Mail3Icon, PhoneIcon } from "../Molecules/icons";
import { BasicHeroSection } from "../Organisms/BasicHeroSection";
import { MarkupText } from "../Organisms/PageContent/MarkupText";
export function Team(props) {
    var _props_firstName;
    return /*#__PURE__*/ React.createElement("div", {
        className: "mb-16 md:mb-20"
    }, /*#__PURE__*/ React.createElement(BasicHeroSection, {
        title: "".concat(props.firstName, " ").concat(props.lastName),
        breadcrumbs: props.breadcrumbs
    }), /*#__PURE__*/ React.createElement("article", {
        className: "container-page paragraph-container flex flex-col md:flex-row w-full gap-12 md:gap-20 items-center justify-center flex-1"
    }, /*#__PURE__*/ React.createElement("aside", {
        className: "flex flex-col items-center gap-4"
    }, props.portrait && /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col w-[220px]"
    }, /*#__PURE__*/ React.createElement(Image, {
        className: "w-[220px] h-auto rounded-[50%] object-cover",
        source: props.portrait,
        alt: (_props_firstName = props.firstName) !== null && _props_firstName !== void 0 ? _props_firstName : ""
    })), /*#__PURE__*/ React.createElement("p", {
        className: "mb-0"
    }, props.jobPosition), props.phone && /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row gap-1 items-center "
    }, /*#__PURE__*/ React.createElement(PhoneIcon, {
        "aria-hidden": "true"
    }), /*#__PURE__*/ React.createElement("a", {
        href: "tel:".concat(props.phone),
        className: "break-words m-0 no-underline"
    }, props.phone)), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-row items-end gap-4 justify-center not-prose"
    }, props.email && /*#__PURE__*/ React.createElement("a", {
        key: props.email,
        href: "mailto:".concat(props.email),
        className: "text-green-500 hover:text-green-800 transition focus-dark"
    }, /*#__PURE__*/ React.createElement(Mail3Icon, null)), props.linkedInProfile && /*#__PURE__*/ React.createElement(Link, {
        key: props.linkedInProfile,
        href: props.linkedInProfile,
        className: "text-green-500 hover:text-green-800 transition focus-dark"
    }, /*#__PURE__*/ React.createElement(LinkedIn2Icon, null)))), /*#__PURE__*/ React.createElement("main", {
        className: "container-text"
    }, props.description && /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.description
    }))));
}
